import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, styled } from '@mui/material';

const SectionPlaceholder = styled(Box)({
  height: 200,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

type Props = {
  children: React.ReactNode;
  index: number;
};

const LazySection: React.FC<Props> = ({ children, index }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let observer: IntersectionObserver | undefined;

    const timeout = setTimeout(() => {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer?.disconnect();
          }
        },
        { rootMargin: '600px' },
      );
      observer.observe(el);
    }, (index + 1) * 150);

    return () => {
      clearTimeout(timeout);
      observer?.disconnect();
    };
  }, [index]);

  return (
    <div ref={ref}>
      {!isVisible && (
        <SectionPlaceholder>
          <CircularProgress />
        </SectionPlaceholder>
      )}
      {isVisible ? children : null}
    </div>
  );
};

export default LazySection;
